import { render, staticRenderFns } from "./RoomCanteen.vue?vue&type=template&id=6c6ca4a7"
import script from "./RoomCanteen.vue?vue&type=script&lang=js"
export * from "./RoomCanteen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports